import React, { useState, useRef } from 'react';

// Simplified Philippine region paths (SVG approximations for major island groups/regions)
const REGION_PATHS = [
  {
    id: 'ncr',
    name: 'NCR',
    fullName: 'National Capital Region',
    island: 'Luzon',
    d: 'M 310 295 L 325 290 L 335 300 L 330 315 L 315 318 L 305 308 Z',
    labelX: 318,
    labelY: 305,
  },
  {
    id: 'region1',
    name: 'Region I',
    fullName: 'Ilocos Region',
    island: 'Luzon',
    d: 'M 255 155 L 280 140 L 295 155 L 300 185 L 290 210 L 270 215 L 255 200 L 248 175 Z',
    labelX: 275,
    labelY: 178,
  },
  {
    id: 'car',
    name: 'CAR',
    fullName: 'Cordillera Administrative Region',
    island: 'Luzon',
    d: 'M 290 155 L 320 145 L 345 160 L 350 185 L 335 205 L 310 210 L 292 195 L 288 170 Z',
    labelX: 318,
    labelY: 178,
  },
  {
    id: 'region2',
    name: 'Region II',
    fullName: 'Cagayan Valley',
    island: 'Luzon',
    d: 'M 330 130 L 365 120 L 385 140 L 380 175 L 360 190 L 340 185 L 328 165 Z',
    labelX: 357,
    labelY: 158,
  },
  {
    id: 'region3',
    name: 'Region III',
    fullName: 'Central Luzon',
    island: 'Luzon',
    d: 'M 270 215 L 310 210 L 340 220 L 345 250 L 330 268 L 300 272 L 275 260 L 262 238 Z',
    labelX: 305,
    labelY: 242,
  },
  {
    id: 'region4a',
    name: 'Region IV-A',
    fullName: 'CALABARZON',
    island: 'Luzon',
    d: 'M 300 272 L 340 268 L 360 280 L 355 310 L 335 325 L 308 320 L 295 305 Z',
    labelX: 328,
    labelY: 297,
  },
  {
    id: 'region4b',
    name: 'Region IV-B',
    fullName: 'MIMAROPA',
    island: 'Luzon',
    d: 'M 240 310 L 270 300 L 285 315 L 280 345 L 258 355 L 238 342 L 232 325 Z',
    labelX: 258,
    labelY: 328,
  },
  {
    id: 'region5',
    name: 'Region V',
    fullName: 'Bicol Region',
    island: 'Luzon',
    d: 'M 355 310 L 385 305 L 405 320 L 410 350 L 395 370 L 370 368 L 352 350 L 348 328 Z',
    labelX: 380,
    labelY: 338,
  },
  {
    id: 'region6',
    name: 'Region VI',
    fullName: 'Western Visayas',
    island: 'Visayas',
    d: 'M 270 390 L 305 380 L 325 395 L 320 425 L 298 435 L 272 425 L 262 408 Z',
    labelX: 294,
    labelY: 408,
  },
  {
    id: 'region7',
    name: 'Region VII',
    fullName: 'Central Visayas',
    island: 'Visayas',
    d: 'M 340 390 L 375 382 L 392 398 L 388 428 L 365 438 L 342 428 L 332 412 Z',
    labelX: 362,
    labelY: 410,
  },
  {
    id: 'region8',
    name: 'Region VIII',
    fullName: 'Eastern Visayas',
    island: 'Visayas',
    d: 'M 400 370 L 432 362 L 448 378 L 445 408 L 425 420 L 402 412 L 392 395 Z',
    labelX: 420,
    labelY: 392,
  },
  {
    id: 'region9',
    name: 'Region IX',
    fullName: 'Zamboanga Peninsula',
    island: 'Mindanao',
    d: 'M 255 470 L 290 460 L 308 475 L 305 505 L 282 515 L 258 505 L 248 488 Z',
    labelX: 278,
    labelY: 488,
  },
  {
    id: 'region10',
    name: 'Region X',
    fullName: 'Northern Mindanao',
    island: 'Mindanao',
    d: 'M 330 455 L 368 448 L 385 462 L 382 492 L 360 502 L 335 495 L 322 478 Z',
    labelX: 354,
    labelY: 475,
  },
  {
    id: 'region11',
    name: 'Region XI',
    fullName: 'Davao Region',
    island: 'Mindanao',
    d: 'M 370 495 L 408 488 L 425 505 L 420 538 L 398 548 L 372 540 L 360 522 Z',
    labelX: 392,
    labelY: 518,
  },
  {
    id: 'region12',
    name: 'Region XII',
    fullName: 'SOCCSKSARGEN',
    island: 'Mindanao',
    d: 'M 305 505 L 340 498 L 358 512 L 355 542 L 332 552 L 308 542 L 298 525 Z',
    labelX: 328,
    labelY: 525,
  },
  {
    id: 'caraga',
    name: 'CARAGA',
    fullName: 'Caraga Region',
    island: 'Mindanao',
    d: 'M 408 448 L 445 440 L 462 455 L 458 488 L 438 498 L 412 490 L 400 472 Z',
    labelX: 432,
    labelY: 468,
  },
  {
    id: 'barmm',
    name: 'BARMM',
    fullName: 'Bangsamoro',
    island: 'Mindanao',
    d: 'M 268 530 L 305 522 L 322 538 L 318 568 L 295 578 L 270 568 L 260 550 Z',
    labelX: 290,
    labelY: 550,
  },
];

const INTENSITY_COLORS = ['#1A1D24', '#2A2E3A', '#8B92A5', '#D4AF37', '#EF4444', '#DC2626'];

function getIntensityColor(value, max) {
  const ratio = value / max;
  if (ratio >= 0.85) return INTENSITY_COLORS?.[5];
  if (ratio >= 0.65) return INTENSITY_COLORS?.[4];
  if (ratio >= 0.45) return INTENSITY_COLORS?.[3];
  if (ratio >= 0.28) return INTENSITY_COLORS?.[2];
  if (ratio >= 0.12) return INTENSITY_COLORS?.[1];
  return INTENSITY_COLORS?.[0];
}

export default function PhilippineMapSVG({ regionsData, selectedRegion, onRegionClick, onRegionHover, onRegionLeave, zoom }) {
  const svgRef = useRef(null);
  const scale = zoom / 100;

  const maxRevenue = Math.max(...regionsData?.map(r => r?.revenue));
  const maxVolume = Math.max(...regionsData?.map(r => r?.volume));
  const maxAccounts = Math.max(...regionsData?.map(r => r?.accounts));

  const getRegionData = (id) => regionsData?.find(r => r?.id === id);

  const getColor = (id) => {
    const data = getRegionData(id);
    if (!data) return '#F1F5F9';
    return getIntensityColor(data?.revenue, maxRevenue);
  };

  const handleMouseMove = (e, regionPath) => {
    const data = getRegionData(regionPath?.id);
    if (!data) return;
    const rect = svgRef?.current?.getBoundingClientRect();
    if (rect) {
      onRegionHover(data, {
        x: e?.clientX - rect?.left,
        y: e?.clientY - rect?.top,
      });
    }
  };

  return (
    <div className="w-full h-full flex items-center justify-center overflow-hidden">
      <svg
        ref={svgRef}
        viewBox="220 110 280 490"
        className="w-full h-full"
        style={{ transform: `scale(${scale})`, transformOrigin: 'center', transition: 'transform 0.3s ease' }}
        aria-label="Interactive Philippine map showing regional sales data"
        role="img"
      >
        {/* Ocean background */}
        <rect x="220" y="110" width="280" height="490" fill="#1A2535" opacity="0.6" rx="8" />

        {/* Island group labels */}
        <text x="290" y="130" fontSize="7" fill="#8B92A5" fontFamily="Inter" textAnchor="middle" fontWeight="500">LUZON</text>
        <text x="360" y="445" fontSize="7" fill="#8B92A5" fontFamily="Inter" textAnchor="middle" fontWeight="500">VISAYAS</text>
        <text x="355" y="460" fontSize="7" fill="#8B92A5" fontFamily="Inter" textAnchor="middle" fontWeight="500">MINDANAO</text>

        {REGION_PATHS?.map((regionPath) => {
          const data = getRegionData(regionPath?.id);
          const isSelected = selectedRegion?.id === regionPath?.id;
          const fillColor = getColor(regionPath?.id);

          return (
            <g key={regionPath?.id}>
              <path
                d={regionPath?.d}
                fill={fillColor}
                stroke={isSelected ? '#D4AF37' : '#3A3E4A'}
                strokeWidth={isSelected ? 1.5 : 0.5}
                className="cursor-pointer"
                style={{
                  filter: isSelected
                    ? 'drop-shadow(0 0 8px rgba(220,38,38,0.7)) drop-shadow(0 0 16px rgba(212,175,55,0.45))'
                    : 'none',
                  opacity: isSelected ? 1 : 0.9,
                  transition: 'filter 0.3s ease, opacity 0.3s ease, stroke 0.25s ease, stroke-width 0.25s ease',
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.filter = 'drop-shadow(0 0 6px rgba(220,38,38,0.65)) drop-shadow(0 0 12px rgba(212,175,55,0.35)) brightness(1.18)';
                  e.currentTarget.style.opacity = '1';
                  e.currentTarget.style.strokeWidth = '1.2';
                  e.currentTarget.style.stroke = 'rgba(212,175,55,0.7)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.filter = isSelected ? 'drop-shadow(0 0 8px rgba(220,38,38,0.7)) drop-shadow(0 0 16px rgba(212,175,55,0.45))' : 'none';
                  e.currentTarget.style.opacity = isSelected ? '1' : '0.9';
                  e.currentTarget.style.strokeWidth = isSelected ? '1.5' : '0.5';
                  e.currentTarget.style.stroke = isSelected ? '#D4AF37' : '#3A3E4A';
                  onRegionLeave();
                }}
                onClick={() => data && onRegionClick(data)}
                onMouseMove={(e) => handleMouseMove(e, regionPath)}
                aria-label={`${regionPath?.fullName} - click for details`}
                role="button"
                tabIndex={0}
                onKeyDown={(e) => e?.key === 'Enter' && data && onRegionClick(data)}
              />
              {/* Region label */}
              <text
                x={regionPath?.labelX}
                y={regionPath?.labelY}
                fontSize="4.5"
                fill={isSelected ? '#D4AF37' : '#E8EBF0'}
                fontFamily="Inter"
                textAnchor="middle"
                fontWeight={isSelected ? '700' : '500'}
                className="pointer-events-none select-none"
              >
                {regionPath?.name}
              </text>
            </g>
          );
        })}
      </svg>
    </div>
  );
}